import { useParams } from "react-router-dom";
import { FaLinkedin } from "react-icons/fa";
import teamMembers from "./teamMembers";
import "./MemberProfile.css";

function MemberProfile() {
  const { slug } = useParams();

  const member = teamMembers.find((item) => item.slug === slug);

  if (!member) {
    return <h2>Member not found.</h2>;
  }

  return (
    <div className="member-profile">
      <div className="member-profile__card">
        {/* Left Side - Image */}
        <div className="member-profile__image-container">
          <img
            src={member.image}
            alt={member.name}
            className="member-profile__image"
          />
        </div>

        {/* Right Side - Content */}
        <div className="member-profile__content">
          <h1>{member.name}</h1>

          <h3>{member.role}</h3>

          {member.bio.map((paragraph, index) => (
            <p key={index} className="member-profile__bio">
                {paragraph}
            </p>
    ))}

          {member.linkedin && (
            <a
              href={member.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="linkedin-button"
            >
              <FaLinkedin size={28} />
              <span></span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default MemberProfile;